<template>
  <form @submit="formSubmit">
    <div class="login-block form-start-block">
      <div class="form-group row">
        <div class="col col-sm-6 text-left font-14 pr-1">
          First Name
          <input
            type="text"
            class="form-control"
            v-model="firstName"
            :class="{ error: $v.firstName.$error }"
          />
        </div>
        <div class="col col-sm-6 text-left font-14 pl-1">
          Last Name
          <input
            type="text"
            class="form-control"
            v-model="lastName"
            :class="{ error: $v.lastName.$error }"
          />
        </div>
      </div>
      <div class="form-group row" v-if="branches && branches.length">
        <div class="col text-left font-14">
          Branch / Station
          <select
            v-model="selectedBranch"
            class="form-control"
            @change="onBranchChanged()"
          >
            <option value="">- Select Branch / Station -</option>
            <option v-for="b in branches" :value="b.Id" :key="b.Id">
              {{ b.Name }}
            </option>
          </select>
        </div>
      </div>
      <div class="form-group row" v-if="departments && departments.length">
        <div class="col text-left font-14">
          Department
          <select v-model="selectedDepartment" class="form-control">
            <option value="">- Select Department -</option>
            <option
              v-for="dep in departmentsList"
              :value="dep.Id"
              :key="dep.Id"
            >
              {{ dep.Name }}
            </option>
          </select>
        </div>
      </div>
      <div class="form-group row">
        <div class="col text-left font-14">
          Password
          <input
            type="password"
            class="form-control"
            v-model="password"
            :class="{ error: $v.password.$error }"
          />
          <div class="text-secondary password-hint">
            Password must be at least 8 characters (20 max) and must include 1
            uppercase letter, 1 lowercase letter, and 1 number.
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col text-left font-14">
          Re-enter password
          <input
            type="password"
            class="form-control"
            v-model="repassword"
            :class="{ error: $v.repassword.$error }"
          />
        </div>
      </div>
    </div>

    <div class="row mt-3" v-if="notification">
      <div class="col">
        <div class="notification p-3 text-center" v-html="notification"></div>
      </div>
    </div>

    <div class="row form-button">
      <div class="col">
        <button type="submit" class="btn btn-info btn-sm px-4">Save</button>
      </div>
    </div>
  </form>
</template>

<script>
import WdxBaseComponentMixin from '../../common/mixins/wdxBaseComponent';
import { required, sameAs, helpers } from 'vuelidate/lib/validators';
import loginComponentMixin from './loginComponentMixin';

const pwdValidator = helpers.regex(
  'pwdValidator',
  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z\!\@\#\$\%\^\&\*\)\(\+\=\.\<\>\{\}\[\]\:\;\'\"\|\~\`\_\-]{8,}$/
);

export default {
  mixins: [WdxBaseComponentMixin, loginComponentMixin],
  props: ['departments', 'branches'],
  data() {
    return {
      firstName: '',
      lastName: '',
      password: '',
      repassword: '',
      notification: null,
      selectedDepartment: '',
      selectedBranch: '',
      departmentsList: []
    };
  },
  validations: {
    firstName: {
      required
    },
    lastName: {
      required
    },
    password: {
      required,
      pwdValidator
    },
    repassword: {
      required,
      sameAsPassword: sameAs('password')
    }
  },
  computed: {},
  watch: {
    branches: function () {
      this.onBranchChanged();
    }
  },
  mounted: function () {
    if (this.branches) {
      this.onBranchChanged();
    }
  },
  methods: {
    formSubmit(e) {
      e.preventDefault();

      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.notification = null;

      this.$userService
        .updateRegistrationInformation(
          this.firstName,
          this.lastName,
          this.password,
          this.selectedBranch,
          this.selectedDepartment
        )
        .then((response) => {
          if (response.data) {
            const result = response.data;
            const redirectUrl = this.getRedirectUrl(result.DefaultPageUrl);

            if (result.Errors && result.Errors.length > 0) {
              this.notification = result.Errors.map((e) => e.Error).join(
                '<br/>'
              );
            } else if (redirectUrl) {
              window.location = redirectUrl;
            } else {
              this.notification = 'There is an error.';
            }
          } else {
            this.notification = 'Your registration information was not found.';
          }
        })
        .catch((error) => {
          this.handleHttpError(error, true);
        });
    },

    onBranchChanged() {
      let branchId = '';
      if (this.selectedBranch) {
        branchId = this.selectedBranch;
      }

      this.departmentsList = this.departments.filter(
        (d) => d.ParentId == branchId
      );
    }
  }
};
</script>

<style></style>
